import MuiForms from 'mui-forms';
import React, {useMemo} from 'react';
import styled from 'styled-components';
import {ThemeProvider} from '@mui/material/styles';

import {getMuiFormsTheme} from 'styles/MuiFormsTheme';
import {useTheme} from 'styles/ThemeContext';

export default function MuiForm(props) {
  const {themes, currentTheme} = useTheme();
  const muiTheme = useMemo(() => getMuiFormsTheme(themes[currentTheme]), [themes, currentTheme]);

  return (
    <ThemeProvider theme={muiTheme}>
      <FormWrapper>
        <MuiForms
          config={{
            variant: 'standard',
          }}
          changeResponseMode={'form-data'}
          {...props}
          className={`mui-form-wrapper ${props?.className || ''}`}
        />
      </FormWrapper>
    </ThemeProvider>
  );
}

const FormWrapper = styled.div`
  height: 100%;

  .mui-form-wrapper {
    height: 100%;
  }

  .stepper {
    margin: 2rem;
    opacity: 0;
  }

  .input-container {
    margin-bottom: 1rem;
    position: relative;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
    }
  }
  .Mui-disabled {
    &:after {
      content: '🔒';
    }

    input {
      background-color: #6d6c6c39 !important;
      color: #39393982 !important;
      -webkit-text-fill-color: #39393982 !important;
      font-weight: 600 !important;
      padding-left: 0.2rem !important;
    }
  }

  .input-container label {
    font-size: ${(props) => props.theme.typography.fontSize.sm};
    font-weight: 400;
    color: #7e7e7e;
  }

  .input-container label + div {
    font-size: ${(props) => props.theme.typography.fontSize.sm};
    font-weight: 400;
    color: #000000;
  }

  .action-btn {
    button {
      padding: 1rem 0;
      background: #6725f4;
      border-radius: 52px;
      width: 100%;
      margin-top: 0rem;
      color: #ffffff;
      font-size: ${(props) => props.theme.typography.fontSize.sm};
      font-family: MavenPro;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: scale 300ms;

      :hover {
        background-color: #6725f4;
        scale: 1.02;
      }
    }
  }

  .prev-action-btn {
    padding: 1rem 0;
    background: transparent;
    color: #6725f4;
    border-radius: 52px;
    width: 100%;
    margin-top: 3rem;
    font-size: ${(props) => props.theme.typography.fontSize.sm};
    font-family: MavenPro;
    font-weight: 500;
    display: flex;
    justify-content: left;
    align-items: center;

    :hover {
      background: transparent;
    }
  }

  .footer {
    margin-top: auto;
    display: flex;
    flex-direction: column;
  }

  .MuiFormHelperText-root {
    margin-top: 0rem !important;
  }

  form {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .meta-form-control-paragraph {
    font-size: 0.8rem;
    font-weight: 400;
    line-height: 1.5;
    text-align: start;
    color: #7e7e7e;
    &:before {
      content: '🞷';
      margin-right: 0.2rem;
      color: #7e7e7e;
    }
  }

  .mui-form-heading-text {
    background-color: #f8f2ff;
    border-radius: 8px;
    padding: 1.143rem;
    display: flex;
    align-items: flex-start;
    gap: 0.571rem;
    margin-top: 1.714rem;
    font-family: Maven, sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #6725f4;
    :before {
      content: '🞷';
      margin-right: 0.571rem;
      color: #6725f4;
    }
  }

  .mui-form-section {
    font-size: 1.3rem;
    font-weight: 500;
    line-height: 1.5;
    text-align: start;
    color: #3e3d3d;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    margin-left: -0.5rem;

    &::before {
      content: '';
    }
  }
`;
